import React, { useRef, useState } from 'react';
import { InputNumero } from '../../../../Numeros/input-numero';
import {Col, Row, Form, Button, Modal} from 'antd';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPlus} from '@fortawesome/pro-solid-svg-icons';
import { ProdutoSimplesSelector } from '../../custom-inputs/produto-simples-selector';
import { newProduto } from '../../store/produto.domain';
import { useDispatch, useSelector } from 'react-redux';
import {  atualizaProduto } from '../../store/cadastro-produto.reducer';
import {  newComposicao } from '../../store/composicao.domain';



const FormPreencheComposicao = (props) => {
    const {getApi, form} = props

    // const {form} = Form.useFormInstance();
    
    const [produtoSelecionado, setProdutoSelecionado] = useState(null);
    const [quantidadeSelecionada, setQuantidadeSelecionada] = useState(0);
    // const [inputNumeroValue, setInputNumeroValue] = useState({floatValue: 0, textValue: ""});
    const [autoCompleteKey, setAutoCompleteKey] = useState(1);

    const inputRef = useRef(null)
    const autoCompleteRef = useRef(null)


    const dispatch = useDispatch();

    const {produto:dadosProduto} = useSelector(state => state.produto);

    const produto = newProduto(dadosProduto);



    const changeQuantidadeHandle = ({floatValue}) => {
        console.log("quantidade selecionada", floatValue);
        setQuantidadeSelecionada(floatValue);
    }


    const adicionarHandleClick = ()=> {
        if(!produtoSelecionado){

            Modal.error({
                title: "Selecione um produto",
                description: "Você deve selecionar um produto para adicionar uma composicao"
            })
            return;
        }

        if(!quantidadeSelecionada){
            Modal.error({
                title: "Informe a quantidade",
                description: "Você deve informar a quantidade para compor o produto"
            })
            return;
        }

        produto.addComposicao(newComposicao({
            produto: produtoSelecionado,
            quantidadeUtilizada: quantidadeSelecionada
        }));

        dispatch(atualizaProduto(produto.toPlainJson()));
        setProdutoSelecionado(null);
        setQuantidadeSelecionada(0);
        
        console.log("composicao_quantidadeUtilizada", form.getFieldValue("composicao_quantidadeUtilizada"))
        form.setFieldsValue({
            "composicao.produto": "",
            "composicao_quantidadeUtilizada": ""
        });

        
        setAutoCompleteKey(autoCompleteKey+1);
        
        setTimeout(()=> {
            // setInputNumeroValue("");
            inputRef.current.value = "";
            autoCompleteRef.current.value = ''
            autoCompleteRef.current.focus({
                preventScroll: true,
            });
        }, 100);
        


    }

    let unMedida = '';

    if(produtoSelecionado){
        unMedida = produtoSelecionado.props.uCom;
    }

    // let inputValue = "";
    // if(inputRef.current && inputRef.current.value){
    //     inputValue = inputRef.current.value;
    // }
    return <Row gutter={[8,0]} align={"middle"}>
        <Col>
            <Form.Item label="Escolha um item para compor o produto" name="composicao.produto" >
                <ProdutoSimplesSelector 
                    innerRef={autoCompleteRef}
                    key={autoCompleteKey}
                    onSelect={(produto)=> {
                    if(!produto){
                        setProdutoSelecionado(null);
                        return;
                    }

                    
                    setProdutoSelecionado(newProduto(produto))
                    
                    setTimeout(()=> inputRef.current.focus({
                        preventScroll: true,
                    }), 100)

                    //setTimeout(()=> inputRef.current.val = "", 100)
                    // document.getElementById("composicao.quantidade").focus();

                }} getApi={getApi}></ProdutoSimplesSelector>
            </Form.Item>
        </Col>
        <Col>
            <Form.Item label="Quantidade" key={autoCompleteKey} name="composicao_quantidadeUtilizada">
                <InputNumero innerRef={inputRef} onKeyPress={(evt)=> evt.key=="Enter"? adicionarHandleClick(evt) : ''} onChange={changeQuantidadeHandle}  addonAfter={unMedida || false} />
            </Form.Item>
        </Col>
        <Col align={"bottom"} style={{height: "28px"}}>
            
                <Button onClick={adicionarHandleClick} type="primary" icon={<FontAwesomeIcon icon={faPlus}></FontAwesomeIcon>}>&nbsp;Adicionar</Button>

            
            
        </Col>
    </Row>
}

export {FormPreencheComposicao};